import {onReady} from "../functions";
import aosInit from "./aos/aos";
import initTypedJS from "./typed/typed";
import initParallax from "./parallax/parallax";
import initVGNav from "./vegas/vgnav";
import enableCarousel from "./swiper/carousel";
import enableAccordion from "./accordion/accordion";
import initVGSpy from "./vegas/spy";
import setIndentAfterOpenModule from "./vegas/_ui";

onReady(() => {
	/**
	 * AOS Animation init
	 */
	aosInit();

	/**
	 * Init type text
	 */
	initTypedJS();

	/**
	 * Init parallax
	 */
	initParallax()

	/**
	 * Init site navigation
	 */
	initVGNav()

	/**
	 * Init Swiper Carousel
	 */
	enableCarousel()

	/**
	 * Init accordion
	 */
	enableAccordion()

	/**
	 * Init spy
	 */
	initVGSpy()

	/**
	 * Other
	 */
	setIndentAfterOpenModule('modal');
	setIndentAfterOpenModule('sidebar');
});
